import React from "react";
import { useNavigate } from "react-router-dom";
import { HouseDoorFill, ExclamationTriangleFill } from "react-bootstrap-icons";

const NoURLFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col items-center justify-center p-4 font-sans">
      
      <div className="relative w-full max-w-[420px] bg-white pt-16 pb-12 px-8 rounded-[48px] shadow-2xl shadow-slate-200/50 flex flex-col items-center text-center overflow-hidden border border-white animate-in fade-in zoom-in slide-in-from-bottom-8 duration-700">
        
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
          <span className="text-[180px] font-black text-slate-50/80">
            404
          </span>
        </div>

        <div className="relative z-10 mb-8 animate-bounce transition-all duration-1000" style={{ animationIterationCount: 'infinite', animationDuration: '3s' }}>
          <div className="w-24 h-24 bg-white rounded-[32px] shadow-xl flex items-center justify-center border border-slate-50 ring-8 ring-slate-50/50">
            <ExclamationTriangleFill className="text-[#F27405] text-5xl" />
          </div>
          <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-12 h-1.5 bg-slate-200/50 blur-sm rounded-full"></div>
        </div>

        <div className="relative z-10">
          <h2 className="text-2xl font-black text-[#0F172A] mb-3">
            Oops! Page Not Found
          </h2>
          <p className="text-slate-400 font-medium text-sm leading-relaxed mb-10 px-4">
            The page you are looking for might have been removed or is temporarily unavailable.
          </p>
        </div>

        <div className="relative z-10 w-full flex flex-col gap-3">
          <button
            onClick={() => navigate("/")}
            className="w-full py-4 bg-[#F27405] text-white rounded-full font-extrabold text-[11px] uppercase tracking-[0.2em] shadow-lg shadow-orange-500/40 hover:brightness-110 active:scale-95 transition-all duration-200 flex items-center justify-center gap-2"
          >
            <HouseDoorFill size={16} className="mb-0.5" />
            BACK TO HOME
          </button>
        </div>
      </div>

      <div className="mt-12 animate-pulse">
        <p className="text-[10px] font-bold text-slate-300 uppercase tracking-[0.4em]">
          JUSTFORPOINTS SECURITY SYSTEM
        </p>
      </div>

    </div>
  );
};

export default NoURLFoundPage;